import { transformLabelToPath } from '@/util/transform-label-to-path';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const InitSelectedOptionByQuery = props => {
  const { configurableOptions, setIsInitBySearchParams } = props;

  const searchParams = useSearchParams();
  const { setValue, getValues } = useFormContext();

  useEffect(() => {
    setIsInitBySearchParams(false);

    if (!Array.isArray(configurableOptions) || configurableOptions.length === 0) return;

    const values = getValues();

    for (const configurableOption of configurableOptions) {
      const attributeLabel = configurableOption?.label;
      const attributeCode = configurableOption?.attribute_code;

      if (!attributeLabel || !attributeCode) continue;

      const queryKey = transformLabelToPath(attributeLabel);
      const hasValue = values[attributeCode];
      const queryValue = searchParams.get(queryKey);

      if (hasValue || !queryValue) continue;

      const value = configurableOption.values?.find(
        x => transformLabelToPath(x.default_label) === transformLabelToPath(decodeURIComponent(queryValue)),
      );

      if (!value) continue;

      setValue(attributeCode, {
        uid: value.uid,
        label: value.default_label,
        option_attribute_id: configurableOption.attribute_id,
        option_selection_value: value.value_index,
      });
    }
  }, [configurableOptions, searchParams, setIsInitBySearchParams, setValue, getValues]);

  return null;
};

export default InitSelectedOptionByQuery;
